import type { ExtractPropTypes } from "vue";
import type { ModuleInfo } from "../../index";
import type { LayoutProps } from "../../../../main/index";

export const ModulePropsOption = {
    mode: { type: String, required: true },
    data: { type: Object as PropType<ModuleInfo>, required: true },
    origin: { type: Object as PropType<LayoutProps>, required: true },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;
